<template lang="html">
  <div class="ui main container">
    <CategorySelector @onSelectionChanged="loadCategoryProds" />
    <div class="ui stackable grid">
      <div class="seven wide column">
        <div class="ui segment">
          <lingallery
            v-if="isProductLoaded"
            :iid.sync="picId"
            :showControls="false"
            :items="images"
            :addons="{ enableLargeView: true }"
            :startImage="0"
          />
        </div>
      </div>
      <div class="seven wide column">
        <div class="ui segment">
          <h2 class="ui header">
            {{ product.name }}
            <div class="sub header">{{ product.brands[0].name }}</div>
          </h2>
          <p class="ui medium">
            {{ product.description }}
          </p>
          <h4 v-if="product.color">
            Color:
            <b>{{ product.color }}</b>
          </h4>
          <h4>Precio</h4>
          <div class="ui tag labels">
            <a class="ui red large label" v-if="showWholesalePrice">
              {{ wholesalePrice | numeralFormat('$ 0,0.00') }}
            </a>
            <a v-else class="ui red large label">
              {{ price | numeralFormat('$ 0,0.00') }}
            </a>
            <a class="ui large label" v-if="showWholesalePrice">
              {{ price | numeralFormat('$ 0,0.00') }}
            </a>
          </div>
          <h4>Seleccione tamaño</h4>

          <p>
            <sui-dropdown
              placeholder="Tamaño"
              selection
              :options="stockOpts"
              v-model="current"
            />
          </p>
          <h4>Cantidad</h4>
          <div class="">
            <vue-numeric-input
              v-if="currentStock"
              v-model="quantity"
              :min="1"
              :max="currentStock.stock"
              :step="1"
              :precision="0"
              size="100px"
              align="center"
            ></vue-numeric-input>
          </div>
          <h4></h4>
          <div class="">
            <button
              class="ui blue button icon"
              type="button"
              @click="addTocart"
            >
              <i class="ui cart icon"></i>
              Agregar al carrito
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueNumericInput from 'vue-numeric-input';
import CategorySelector from '../../components/app/CategorySelector';
import Lingallery from 'lingallery';

export default {
  name: 'ProductDetails',
  created: async function() {
    const productId = this.$route.params['productId'];

    if (productId) {
      const product = await this.$store.dispatch(
        'products/productById',
        productId
      );

      this.product = product;
      this.isProductLoaded = true;
    }
  },
  computed: {
    stockOpts: function() {
      const cart = this.$store.getters['cart/getCart'];

      const options = this.product.stocks
        .filter(s => s.stock > 0 && !cart.products.find(p => p._id === s._id))
        .map(s => {
          return { value: s._id, text: s.attribute, stock: s.stock };
        });

      if (options && options.length > 0)
        this.current = options[0] ? options[0].value : '';

      return options;
    },
    currentStock: function() {
      return this.product.stocks.find(s => s._id === this.current);
    },
    images: function() {
      let images = [];

      for (let x = 0; x < this.product.images.length; x++) {
        images.push({
          id: x,
          thumbnail: this.product.images[x].thumbnailUrl,
          src: this.product.images[x].url,
          largeViewSrc: this.product.images[x].largeUrl
        });
      }
      return images;
    },
    wholesalePrice: function() {
      if (!this.isMatrix) {
        return this.price - this.wholesaleDto;
      } else {
        return this.product.wholesalePrice;
      }
    },
    wholesaleDto: function() {
      return this.$store.getters['application/getWholeSaleDto'];
    },
    price: function() {
      if (!this.isMatrix) {
        if (this.product.isLocal) {
          return this.product.shops.find(s => s.shopId === this.shopId).price;
        } else {
          const increment = this.$store.getters['prices/getIncrement'](
            this.product.brands[0]._id
          );

          return this.product.price + increment;
        }
      } else {
        return this.product.price;
      }
    },
    showWholesalePrice: function() {
      return this.$store.getters['application/showWholesalePrice'];
    },
    isMatrix: function() {
      return this.$store.getters['application/isMatrix'];
    },
    shopId: function() {
      return this.$store.getters['application/getId'];
    }
  },
  methods: {
    addTocart: async function() {
      const name =
        this.product.name +
        ' - ' +
        this.product.brands[0].name +
        ' - ' +
        (this.product.color ? this.product.color + ' - T: ' : 'T: ') +
        this.currentStock.attribute;
      const productData = [
        {
          productId: this.product._id,
          attributeId: this.currentStock._id,
          name: name,
          price: this.product.price,
          wholesalePrice: this.product.wholesalePrice,
          shopPrice: this.price,
          shopWholesalePrice: this.wholesalePrice,
          quantity: this.quantity,
          image: this.product.images[0].thumbnailUrl,
          extended1: this.product.extended1,
          extended2: this.product.extended2
        }
      ];

      await this.$store.dispatch('cart/addProduct', { products: productData });
    },
    loadCategoryProds: async function(payload) {
      await this.$store.dispatch(
        'products/loadProductsByCategory',
        payload || {}
      );
      this.$router.push({ name: 'Home', query: { reload: false } });
    }
  },
  data() {
    return {
      picId: 'test',
      isProductLoaded: false,
      product: {
        name: '',
        description: '',
        brand: {
          name: ''
        },
        brands: [{ name: '' }],
        images: [],
        price: 0,
        stocks: [{ _id: '' }]
      },
      current: '',
      quantity: 1,
      zoomerOptions: {
        zoomFactor: 3,
        pane: 'container',
        hoverDelay: 300,
        namespace: 'zoomer-left',
        move_by_click: false,
        scroll_items: 5,
        choosed_thumb_border_color: '#dd2c00',
        scroller_position: 'bottom',
        zoomer_pane_position: 'right'
      }
    };
  },
  components: {
    VueNumericInput,
    CategorySelector,
    Lingallery
  }
};
</script>

<style lang="css">
.responsive-image:not(.preview-box):not(.zoomer-control) {
  max-height: 50px;
  max-width: 50px;
}
.zoomer-control {
  max-height: 28.5px;
  max-width: 28.5px;
}
</style>
